const BACKEND = 'https://nexus360-platform-backend-api-production.up.railway.app';
export const ASSETS_API_URL    = `${BACKEND}/api/assets`;
export const ASSETS_SUBMIT_URL = import.meta.env.VITE_SHEETS_API_URL || '';

export const ASSET_TYPES = [
  'Véhicule de patrouille','Véhicule tout-terrain','Moto de liaison',
  'Camionnette de transport','Fourgon blindé','Ambulance de brigade',
  'Bateau','Hélicoptère','Armement','Équipement de communication',
  'Matériel informatique','Équipement de protection','Générateur',
  'Groupe électrogène','Matériel médical','Autre',
];

export const ASSET_CATEGORIES = [
  'Flotte motorisée','Armement & Sécurité','Communication & TIC',
  'Équipement de terrain','Infrastructure','Matériel médical','Autre',
];

export const ASSET_STATUSES = [
  'Opérationnel','En service limité','En maintenance',
  'En réparation','Hors service','Perdu / Volé','Déclassé',
];

export const ASSET_CONDITIONS = ['Excellent','Bon','Acceptable','Dégradé','Critique'];
export const FUEL_TYPES       = ['Essence','Diesel','Électrique','Hybride','N/A'];
export const LOSS_TYPES       = ['Perte','Vol','Destruction','Saisie judiciaire','Autre'];
export const INSPECTION_RESULTS = ['Conforme','Conforme avec réserves','Non conforme','Suspendu'];
export const DECOMMISSION_REASONS = [
  'Fin de vie','Irréparable','Obsolescence technique',
  'Sinistre total','Cession','Autre',
];
export const REGIONS = [
  'Adamaoua','Centre','Est','Extrême-Nord',
  'Littoral','Nord','Nord-Ouest','Ouest','Sud','Sud-Ouest',
];
export const UNITS = [
  'Brigade Anti-Criminalité','Brigade de Recherches','Brigade Mobile',
  'Compagnie de Sécurisation','Direction Centrale de la Police Judiciaire',
  'Direction de la Surveillance du Territoire','Groupement Mobile d\'Intervention',
  'Police de l\'Air et des Frontières','Police des Frontières',
  'Unité Spéciale d\'Intervention','Autre',
];

export const generateAssetId = (): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  return 'AST-' + Array.from({length:8}, () => chars[Math.floor(Math.random()*chars.length)]).join('');
};
export const generateQRCode = (id: string): string => `NEXUS360-${id}-${Date.now()}`;

export const STATUS_COLORS: Record<string, {color:string;bg:string;border:string}> = {
  'Opérationnel':      {color:'text-green-400', bg:'bg-green-500/10', border:'border-green-500/30'},
  'En service limité': {color:'text-yellow-400',bg:'bg-yellow-500/10',border:'border-yellow-500/30'},
  'En maintenance':    {color:'text-orange-400',bg:'bg-orange-500/10',border:'border-orange-500/30'},
  'En réparation':     {color:'text-orange-400',bg:'bg-orange-500/10',border:'border-orange-500/30'},
  'Hors service':      {color:'text-red-400',   bg:'bg-red-500/10',   border:'border-red-500/30'},
  'Perdu / Volé':      {color:'text-red-500',   bg:'bg-red-600/10',   border:'border-red-600/30'},
  'Déclassé':          {color:'text-gray-400',  bg:'bg-gray-500/10',  border:'border-gray-500/30'},
};
export const CONDITION_COLORS: Record<string,string> = {
  'Excellent':'text-green-400','Bon':'text-blue-400',
  'Acceptable':'text-yellow-400','Dégradé':'text-orange-400','Critique':'text-red-400',
};
